/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconOrbit = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M12 9.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM18.706 12.772A6.75 6.75 0 1 1 12 5.25" />
        <path d="M1.148 14.977C-.489 8.991 3.037 2.811 9.023 1.174S21.189 3.063 22.826 9.05c1.637 5.986-1.889 12.166-7.875 13.803-1.948.533-4.004.53-5.951-.006" />
        <path d="M17.25 5.25a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zM3.75 18a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5z" />
      </g>
    </svg>
  ),
);
